import {
  useDeveloperToolsStore,
  useDeveloperToolsStoreCare,
  Dialog,
  Headline,
  Text,
  RoundedButton,
  Switch,
  Icon,
  SpacingY,
} from "@akina/presentation";

export const DeveloperToolsDialog = () => {
  const developerToolsStore = useDeveloperToolsStore();
  const careStore = useDeveloperToolsStoreCare();

  return (
    <Dialog
      trigger={
        <div className="fixed bottom-4 right-4 z-100">
          <RoundedButton variant="primary">
            <Icon type="accessibility" />
          </RoundedButton>
        </div>
      }>
      <div className="flex w-96 flex-col gap-4">
        <Headline size="3xl">Developer Tools</Headline>

        {/* General Settings */}
        <div className="flex flex-col gap-4">
          <Text size="lg" className="font-medium">
            General
          </Text>
          <div
            tabIndex={0}
            role="button"
            onKeyDown={() => {}}
            onClick={() => developerToolsStore.setUseCmsPreview(!developerToolsStore.useCmsPreview)}
            className="flex w-full flex-row items-center justify-between">
            <Text size="sm">Use CMS Preview</Text>
            <Switch checked={developerToolsStore.useCmsPreview} />
          </div>

          <div
            tabIndex={0}
            onKeyDown={() => {}}
            role="button"
            onClick={() => developerToolsStore.setLogHttpCalls(!developerToolsStore.logHttpCalls)}
            className="flex w-full flex-row items-center justify-between">
            <Text size="sm">Log HTTP Calls</Text>
            <Switch checked={developerToolsStore.logHttpCalls} />
          </div>
        </div>

        <SpacingY level={2} />
        <div className="h-px bg-gray-200" />
        <SpacingY level={2} />

        {/* Performance Settings */}
        <div className="flex flex-col gap-4">
          <Text size="lg" className="font-medium">
            Performance Insights
          </Text>

          <div
            tabIndex={0}
            role="button"
            onKeyDown={() => {}}
            onClick={() => careStore.setShowPerformanceInsights(!careStore.showPerformanceInsights)}
            className="flex w-full flex-row items-center justify-between">
            <div>
              <Text size="sm">Show Performance Insights</Text>
              <Text size="xs" color="text-gray-500">
                Enable performance monitoring overlay
              </Text>
            </div>
            <Switch checked={careStore.showPerformanceInsights} />
          </div>
        </div>
      </div>
    </Dialog>
  );
};
